import React, { useEffect, useState } from "react";
import Navigation from "../../navigation/Navigation";
import { FormControl, Select, MenuItem, InputLabel } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux';
import { getLecturerProjects } from '../../actions/lecturerprojects';
import { updateUsers } from '../../actions/login';
import axios from 'axios';

/**
 * This page presents the user with a dropdown menu to fill out to allow them to make their final project choices.
 * When the choices are submitted it will send the array filled with those choices to the users database.
 * @returns a list of select fields
 */

function MakeChoices() {

    const dispatch = useDispatch();
    const [choice1, setChoice1] = useState({});
    const [choice2, setChoice2] = useState({});
    const [choice3, setChoice3] = useState({});
    const [choice4, setChoice4] = useState({});
    const [choice5, setChoice5] = useState({});
    const [choice6, setChoice6] = useState({});
    const [user, setUser] = useState({})
    const [allUsers, setAllUsers] = useState([]);
    const [id, setID] = useState(null)
    const [selected, setSelected] = useState([]);

    useEffect(() => {
        setID(localStorage.getItem("id"))
        setUser(user);
        if(allUsers.length === 0) {
            getAllUsers();
        }
        dispatch(getLecturerProjects());
    }, [dispatch, allUsers, user, selected]);

      const getAllUsers = () => {
        axios.get('https://project-allocation-schedule.herokuapp.com/users').then(function (response) {
        const users = response.data;
        users.forEach((user) => {
            if(user._id === localStorage.getItem("id")) {
                if(user.choices[0]) {
                    setChoice1(user.choices[0])
                }
                if(user.choices[1]) {
                    setChoice2(user.choices[1])
                }
                if(user.choices[2]) {
                    setChoice3(user.choices[2])
                }
                if(user.choices[3]) {
                    setChoice4(user.choices[3])
                }
                if(user.choices[4]) {
                    setChoice5(user.choices[4])
                }
                if(user.choices[5]) {
                    setChoice6(user.choices[5])
                }
                setSelected(user.choices);
            }
        })
        setAllUsers(response.data);
    })
        .catch(function (error) {
            console.log(error);
        })
        .then(function () {
        });
    }

    let projects = []
    const response = useSelector((state) => state.lecturerprojects.data);
    if (response){
        projects = Array.from(response);
    }

    const handleFirst = (e) => {setChoice1(e.target.value);};
    const handleSecond = (e) => {setChoice2(e.target.value);};
    const handleThird = (e) => {setChoice3(e.target.value);};
    const handleFourth = (e) => {setChoice4(e.target.value);};
    const handleFifth = (e) => {setChoice5(e.target.value);};
    const handleSixth = (e) => {setChoice6(e.target.value);};

    const getTitles = () => {
        return (
            projects.map(project => {
                if(project.title !== choice1.title && project.title !== choice2.title && project.title !== choice3.title && project.title !== choice4.title && project.title !== choice5.title && project.title !== choice6.title) {
                    return (
                        <MenuItem key={project._id} value={project}><p>{project.title}</p></MenuItem>
                    )
                } else {
                    return (
                        <MenuItem disabled key={project._id} value={project}><p>{project.title}</p></MenuItem>
                    )
                }
            })
        )
    }

    /**
     * 
     * @param {*} id 
     * @returns 
     */
    const getTitle = (id) => {
        let title = ""
            projects.forEach(project => {
                if(project._id === id) {
                    title = project.title;
                }
            })
            return title;
    }

    const submitChoices = () => {
        const newUser = Object.assign({}, user)
        const newSelected = Object.assign([], selected)
        if(!newSelected.includes(choice1._id)) {newSelected.push(choice1._id)}
        if(!newSelected.includes(choice2._id)) {newSelected.push(choice2._id)}
        if(!newSelected.includes(choice3._id)) {newSelected.push(choice3._id)}
        if(!newSelected.includes(choice4._id)) {newSelected.push(choice4._id)}
        if(!newSelected.includes(choice5._id)) {newSelected.push(choice5._id)}
        if(!newSelected.includes(choice6._id)) {newSelected.push(choice6._id)}
        
        console.log(newSelected)
        setSelected(newSelected)
        newUser.choices = newSelected;
        setUser(newUser)
        if(id) {
            if(choice1._id === undefined || choice2._id === undefined || choice3._id === undefined || choice4._id === undefined || choice5._id === undefined || choice6._id === undefined) {
                alert("Please ensure that all choices have been selected before submitting")
            } else {
                dispatch(updateUsers(id, newUser));
                alert("Choices have been submitted")
            }
        }
    }

    if(projects) {
        console.log("title",getTitle(choice1))
        return(
            <div className="makeChoicesContainer" style={{marginTop: "100px"}}>
                <Navigation/>
                <form className="paper" id={id} onSubmit={submitChoices}>
                <h1 className="formTitles">Make Choices</h1>
                <FormControl fullWidth>
                    <InputLabel id="selectLabel">1st Choice</InputLabel>
                    <Select labelId="selectLabel" id="select" label="first" value={choice1} onChange={handleFirst}>
                        {getTitles()}
                    </Select>
                </FormControl>
    
                <FormControl fullWidth>
                    <InputLabel id="selectLabel">2nd Choice</InputLabel>
                    <Select labelId="selectLabel" id="select" label="second" value={choice2} onChange={handleSecond}>
                        {getTitles()}
                    </Select>
                </FormControl>
    
                <FormControl fullWidth>
                    <InputLabel id="selectLabel">3rd Choice</InputLabel>
                    <Select labelId="selectLabel" id="select" label="third" value={choice3} onChange={handleThird}>
                        {getTitles()}
                    </Select>
                </FormControl>
    
                <FormControl fullWidth>
                    <InputLabel id="selectLabel">4th Choice</InputLabel>
                    <Select labelId="selectLabel" id="select" label="fourth" value={choice4} onChange={handleFourth}>
                        {getTitles()}
                    </Select>
                </FormControl>
    
                <FormControl fullWidth>
                    <InputLabel id="selectLabel">5th Choice</InputLabel>
                    <Select labelId="selectLabel" id="select" label="fifth" value={choice5} onChange={handleFifth}>
                        {getTitles()}
                    </Select>
                </FormControl>
    
                <FormControl fullWidth>
                    <InputLabel id="selectLabel">6th Choice</InputLabel>
                    <Select labelId="selectLabel" id="select" label="sixth" value={choice6} onChange={handleSixth}>
                        {getTitles()}
                    </Select>
                </FormControl>
                <input className="submitButton" type="submit" name="submit" onClick={() => updateUsers(id, selected)}></input>
                </form>
            </div>
        )
    } else {
        return <></>
    }
}

export default MakeChoices